// timeout.interceptor.ts
import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { catchError, throwError, timeout, TimeoutError } from 'rxjs';

export const timeoutInterceptor = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const messageService = inject(MessageService);
  const TIMEOUT = 30000; // 30 seconds

  return next(req).pipe(
    timeout(TIMEOUT),
    catchError((err) => {
      if (err instanceof TimeoutError) {
        // ← Use instanceof, not err.name
        messageService.add({
          key: 'global',
          severity: 'error',
          summary: 'Request Timeout',
          detail: 'The server took too long to respond. Please try again.',
          life: 3000,
          id: 'toast_' + Date.now() + '_' + Math.random(),
        });

        const timeoutError = new HttpErrorResponse({
          status: 408,
          statusText: 'Request Timeout',
          url: req.url,
        });
        return throwError(() => timeoutError);
      }
      return throwError(() => err);
    })
  );
};
